import { queryStringToObject } from '@fiverr-private/futile/lib/url';
import _ from 'lodash';

const sellerLevels = [
    'Entry level',
    'Level 1 Seller',
    'Level 2 Seller',
    'Top Rated Seller'
];

export const Events = {
    GeneralEvents: {
        VIEWED_PAGE: 'Viewed page',
        INTERACTED: 'Interacted with reviews',
        TAG_CLICKED: 'tag clicked',
        GET_A_QUOTE_CLICKED: 'get a quote clicked',
        CONTACT_ME_CLICKED: 'contact me clicked',
        VIEWED_SELLER_PORTFOLIO: 'Viewed seller portfolio'
    },
    Coupon: {
        DISMISS_BOMBA: 'User Profile Page - Dismiss Coupon bomba',
        SEEN_BOMBA: 'User Profile Page - Seen Coupon bomba',
        OPEN_ARTICLE: 'User Profile Page - Clicked Coupon article link',
        SEEN_MODAL: 'User Profile Page - Seen Coupon modal'
    }
};

export const Pages = {
    USER_PAGE: 'User profile',
    GIG_PAGE: 'Gig page'
};

export function triggerMixPanelEvent(eventName, userData = {}, gigs, extraData = {}) {
    const {
        seller_card,
        buying_reviews,
        portfolio_projects
    } = userData;
    const urlParams = queryStringToObject(window.location.search.replace('?', ''));
    const sourceComponent = urlParams.source
        ? { 'Source component': urlParams.source }
        : {};
    const sellerLevel = _.get(sellerLevels, 'seller_card.user.achievement', sellerLevels[0]);
    const propsData = _.isEmpty(userData) ? {} : {
        'Number of gigs': gigs.length,
        'Number of pro gigs': gigs.filter((gig) => gig.is_pro).length,
        'Number of buying reviews': buying_reviews.total_count,
        'Is pro seller': seller_card.user.is_pro,
        'User Seller Level': sellerLevel,
        'Portfolio exist': !!portfolio_projects.length
    };

    sendMixPanelEvents(eventName, {
        'Page name': Pages.USER_PAGE,
        ...propsData,
        ...sourceComponent,
        ...extraData
    });
}

export const sendMixPanelEvents = (eventName, additionalData = {}) => {
    if (typeof MixpanelWrapper !== 'undefined') {
        MixpanelWrapper.trackEvent(eventName, additionalData);
    }
};
